import Vue from 'vue';
import Vuex from 'vuex';
import mutations from '@/store/mutations.ts';
import storeState from '@/store/storeState.ts';
import openclose from '@/store/actions/openclose.ts';
import actions from '@/store/actions/actions.ts';
import auth from '@/store/actions/auth.ts';
import actionitems from '@/store/actions/actionitems.ts';
import typeahead from '@/store/actions/typeahead.ts';
import notifications from '@/store/actions/notifications.ts';
import onboarding from '@/store/actions/onboarding.ts';
import getters from '@/store/getters.ts';

Vue.use(Vuex);

export default new Vuex.Store({
	state: storeState,
	mutations,
	actions: {
		...auth,
		...openclose,
		...actions,
		...typeahead,
		...actionitems,
		...notifications,
		...onboarding,
	},
	getters,
});
